import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable, catchError, throwError } from 'rxjs';
import { environment } from '../../environments/environment';

export interface ITenantUrlPayload {
  securityUrl: string;
  formsUrl: string;
  centralUrl: string;
  vanityId: string;
  contentUrl: string;
  contentApiUrl: string;
}

export interface IVerifyURLPayload {
  tenantID: string;
}
@Injectable({
  providedIn: 'root'
})
export class TenantApiService {
  private http = inject(HttpClient);

  BASE_URL = environment.urls.tenantApi;
  /**
   * Gets the tenant urls for a Softdocs tenant
   * @param tenantId Softdocs tenant id
   */
  getTenantUrls(tenantId: string): Observable<ITenantUrlPayload> {
    const requestUrl = `${this.BASE_URL}/etrieve/${tenantId}`;
    return this.http.get<ITenantUrlPayload>(requestUrl).pipe(catchError(throwError));
  }

  /**
   * Gets the tenant id from a vanity name
   * @param vanityName
   */
  getTenantIdFromVanity(vanityName: string): Observable<IVerifyURLPayload> {
    const requestUrl = `${this.BASE_URL}/vanity/${vanityName}`;
    return this.http.get<IVerifyURLPayload>(requestUrl).pipe(catchError(throwError));
  }
}
